export const statusActions = {
  USER_ONLINE: "USER_ONLINE",
  GET_DESK_NUMBER: "GET_DESK_NUMBER",
};

export const userOnlineAction = (isOnline) => ({
  type: statusActions.USER_ONLINE,
  payload: isOnline,
});

export const getDeskNumberAction = (deskNo) => ({
  type: statusActions.GET_DESK_NUMBER,
  payload: deskNo,
});
